/**
 * Formate un prix en supprimant les décimales inutiles
 * @param {number|string} price - Le prix à formater
 * @returns {string} - Le prix formaté sans décimales
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined) return '0';
  
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  if (isNaN(numPrice)) return '0';
  
  // Retourner le prix entier sans décimales
  return Math.floor(numPrice).toString();
};

/**
 * Formate un prix avec la devise FCFA
 * @param {number|string} price - Le prix à formater
 * @returns {string} - Le prix formaté avec FCFA
 */
export const formatPriceWithCurrency = (price) => {
  return `${formatPrice(price)} FCFA`;
};
